var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconThunder = function SvgIconThunder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.688 7.29 9.573 6.2l.94-4.648C10.665.805 9.74.326 9.217.882L3.009 7.475a.76.76 0 0 0 .303 1.236L6.427 9.8l-.94 4.648c-.152.748.772 1.226 1.296.671l6.207-6.593a.758.758 0 0 0-.302-1.236",
    clipRule: "evenodd"
  })));
};
export default SvgIconThunder;